import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import List from '../List';
var MenuList = React.forwardRef(function (_a, ref) {
  var childrenProp = _a.children,
      selectedItemRef = _a.selectedItemRef,
      otherProps = __rest(_a, ["children", "selectedItemRef"]);

  var children = React.Children.map(childrenProp || [], function (child) {
    if (!React.isValidElement(child)) {
      return null;
    }

    var childProps = __assign(__assign({}, child.props), {
      ref: child.props.selected && selectedItemRef || child.props.ref
    });

    return _jsx(child.type, __assign({}, childProps));
  });
  return _jsx(List, __assign({
    ref: ref
  }, otherProps, {
    children: children
  }));
});
export default MenuList;